const stepsTrackeoPagosPendientes = {
    1: "visualizacion-seleccion-deuda",
    2: "click-seleccion-deuda",
    3: "visualizacion-deuda-y-medios-de-pago",
    4: "click-avanza-al-pago",
    5: "click-agregar-tarjeta",
    6: "visualizacion-iframe-wondersoft-pago-pendiente",
    7: "click-continuar-iframe-wondersoft",
    8: "visualizacion-mensaje-de-confirmacion",
    9: "click-finalizar"
}

export default stepsTrackeoPagosPendientes;